
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getInvestorApiUrl } from "../../utils/config";
import { ApiRequestParams, handleFetchApi } from "../../utils/api";

// Async thunk for fetching properties
// Assuming fetchpropertylist is an API function that returns property data
export const fetchPropertyDetails = createAsyncThunk<any, string>(
  "propertyDetails/fetchPropertyDetails",
  async (propertyId, { rejectWithValue }) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `properties/${propertyId}`
      }
      const response = await handleFetchApi(params);
      const propertyDetails = response.data.data;  // Adjust based on actual API response
      return propertyDetails;
    } catch (error: any) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


const propertyDetailsSlice = createSlice({
  name: 'propertyDetails',
  initialState: {
    propertyDetails: [],
    loading: false,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPropertyDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPropertyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.propertyDetails = action.payload; // Store the assets (properties)
      })
      .addCase(fetchPropertyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = "Error fetching properties"; // Store the error message
      });
  },
});

export default propertyDetailsSlice.reducer;

